/**
 * Checks if the rooms for the accommodation product are set
 * If not, redirect to Step 1 of that flow.
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct<ProductAccommodation>(to);
    const { firstStepRoute } = useFlow(to);

    if (!product.value.rooms.length) {
        return navigateTo(firstStepRoute.value);
    }
});
